/**
 * EnumService
 * 枚举服务
 */
export default {
  AD_USER: 'AD_USER',
  AD_IDENTIFY_CODE: 'AD_IDENTIFY_CODE'
}



// WEBPACK FOOTER //
// ./src/_ddd/enum.service.js